import React, { useContext, useState } from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonList, IonListHeader, IonAvatar, IonLoading, IonButton, IonToggle } from '@ionic/react';

import './Parameters.css';
import { AuthUserContext } from '../services/Session';
import Firebase, { withFirebase } from '../services/Firebase';
import { environment } from '../environments/environment';

interface ParametersProps {
  firebase: Firebase,
}

const Parameters: React.FC<ParametersProps> = ({ firebase }) => {
  const user = useContext(AuthUserContext);
  const [loading, setLoading] = useState(false);

  const logout = (e: any) => {
    e.preventDefault();
    setLoading(true);
    firebase
    .doSignOut()
    .finally(() => {
      setLoading(false);
    });
  }
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Paramètres</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonLoading isOpen={loading} />
        <IonList>
          {
            user
            ? <div>
              <IonListHeader>
                Compte
              </IonListHeader>
              <IonItem lines='none'>
                <IonAvatar slot='start' className='text-avatar ion-text-uppercase'>
                  {(user.name || '')[0] || (user.email || '')[0]}
                </IonAvatar>
                <IonLabel>
                  <h2>{user.name || user.email}</h2>
                  <p>Compte standard</p>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonButton color='danger' fill='clear' className='logout-link' onClick={logout}>
                  Se déconnecter
                </IonButton>
              </IonItem>
            </div>
            : null
          }
          <IonListHeader>
            Apparence
          </IonListHeader>
          <IonItem>
            <IonLabel>
              Dark Thème : 
            </IonLabel>
            <IonToggle slot='end' onIonChange={({ detail: { checked }}) => { document.body.classList.toggle('dark', checked) }}/>
          </IonItem>
          <IonListHeader>
            Informations
          </IonListHeader>
          <IonItem>
            <IonLabel>
              À propos
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel>
              Conditions d'utilisation
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel>
              Régles de confidentialité
            </IonLabel>
          </IonItem>
          <IonItem href={`mailto:${environment.mail}?subject=[Feedback]`}>
            <IonLabel>
              Aidez-nous
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel>
              Version de l'application
              <p>1.1.0</p>
            </IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default withFirebase(Parameters);
